import type { Team } from 'modules/client/tournaments/domain/types';
import type { ChampionshipTableRowDto } from 'modules/client/tournaments/domain/types/dtos';
import extractTeamStats from 'modules/client/tournaments/domain/utils/extract-team-stats';
import { USER_DEFAULT_AVATAR } from 'shared/constants/links';

function teamMapper(row: ChampionshipTableRowDto): Team {
  const { team, ...rest } = row;

  return {
    id: team.id,
    name: team.name,
    shortName: team.name,
    logo: team.emblem?.externalUrl ?? USER_DEFAULT_AVATAR,
    ...extractTeamStats(rest),
  };
}

export default teamMapper;
